export const rule = { checkaccess : function(name, arr) {
    let check = arr.find(item => {
        return item.name === name;
    });

    return check.perm;
  }
}